<template>
    <section class="dp-layout blackboard-score-page">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <template v-if="schoolId > 0">
                <div class="filter-bar">
                    <el-form :inline="true" size="small">
                        <el-form-item label="年月">
                            <el-date-picker
                                v-model="filterForm.yearMonth"
                                type="month"
                                placeholder="选择月份"
                                value-format="yyyy-MM"
                                style="width: 140px;"
                                @change="handleSearch"
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                            <el-button
                                v-if="hasActionPermission('handleExport')"
                                type="success"
                                :loading="exporting"
                                @click="handleExport"
                            >导出评分包</el-button>
                            <el-button
                                v-if="hasActionPermission('openImportDialog')"
                                type="warning"
                                @click="openImportDialog"
                            >导入得分</el-button>
                        </el-form-item>
                        <div v-if="scopeParts.length" class="scope-bar">
                            <el-tag
                                v-for="(p, i) in scopeParts"
                                :key="i"
                                size="small"
                                :type="p.type || 'info'"
                                effect="plain"
                                class="scope-tag"
                            >{{ p.label }}</el-tag>
                        </div>
                    </el-form>
                </div>

                <el-alert
                    title="导出为压缩包：得分表 + 各班作品照片。导入可传压缩包或得分表，先预览再确认写入。左侧树仅筛选查看。"
                    type="info"
                    :closable="false"
                    show-icon
                    class="tip-alert"
                />

                <div class="tbl-scroll-host">
                    <el-table :data="pagedList" v-loading="loading" border height="100%" class="compact-table">
                        <el-table-column type="index" label="#" width="56" align="center" :index="scoreRowIndex" />
                        <el-table-column
                            v-if="showCampusCol"
                            prop="CampusName"
                            label="校区"
                            min-width="100"
                            show-overflow-tooltip
                        />
                        <el-table-column
                            v-if="showGradeCol"
                            prop="GradeName"
                            label="年级"
                            min-width="100"
                            show-overflow-tooltip
                        />
                        <el-table-column prop="ClassName" label="班级" min-width="130" show-overflow-tooltip />
                        <el-table-column label="作品" width="88" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.HasPhotos ? 'success' : 'info'" size="mini">
                                    {{ scope.row.HasPhotos ? '已交' : '未交' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="评分" width="88" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Score != null">{{ formatScore(scope.row.Score) }}</span>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="校区名次" width="88" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Rank != null">{{ scope.row.Rank }}</span>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="全校名次" width="88" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.SchoolGradeRank != null">{{ scope.row.SchoolGradeRank }}</span>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="德育分" width="88" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.MoralScore != null">{{ formatScore(scope.row.MoralScore) }}</span>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="settleTagType(scope.row.Status)" size="mini">
                                    {{ settleText(scope.row.Status) }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="FailReason" label="原因" min-width="160" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.FailReason || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="hasActionPermission('handleRevoke') && scope.row.Status === 'Settled' && scope.row.ScoreId > 0"
                                    type="text"
                                    size="small"
                                    style="color:#F56C6C"
                                    @click="handleRevoke(scope.row)"
                                >撤销</el-button>
                                <span v-else class="muted">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pager">
                    <el-pagination
                        background
                        layout="total, sizes, prev, pager, next"
                        :current-page="page"
                        :page-size="pageSize"
                        :page-sizes="pageSizes"
                        :total="list.length"
                        @current-change="onPageChange"
                        @size-change="onPageSizeChange"
                    />
                </div>
            </template>

            <div v-else class="no-department-tip">
                <div class="no-department-tip__inner">
                    <i class="el-icon-s-data"></i>
                    <p>请在顶部选择学校；可点学校 / 校区 / 年级查看</p>
                </div>
            </div>
        </section>

        <el-dialog
            :visible.sync="importVisible"
            width="560px"
            custom-class="person-import-dialog"
            :close-on-click-modal="false"
            append-to-body
            @closed="onImportDialogClosed"
        >
            <div slot="title" class="pi-dialog-title">
                <span class="pi-dialog-title__icon"><i class="el-icon-upload2"></i></span>
                <div>
                    <strong>导入黑板报得分</strong>
                    <p>先导出评分包对照作品填分，再上传得分表或整个压缩包</p>
                </div>
            </div>
            <div class="pi-body">
                <div class="pi-steps">
                    <div class="pi-step">
                        <span class="pi-step__no">1</span>
                        <div><strong>导出评分包</strong><em>得分表 + 各班作品</em></div>
                    </div>
                    <i class="el-icon-arrow-right pi-step__arrow"></i>
                    <div class="pi-step">
                        <span class="pi-step__no">2</span>
                        <div><strong>上传文件</strong><em>xlsx / zip</em></div>
                    </div>
                    <i class="el-icon-arrow-right pi-step__arrow"></i>
                    <div class="pi-step">
                        <span class="pi-step__no">3</span>
                        <div><strong>预览确认</strong><em>核对后再写入</em></div>
                    </div>
                </div>
                <el-upload
                    :key="'bb-score-upload-' + importUploadKey"
                    class="pi-upload"
                    drag
                    action="#"
                    :auto-upload="false"
                    :limit="1"
                    :show-file-list="false"
                    accept=".xlsx,.xls,.zip"
                    :on-change="onImportFileChange"
                    :on-remove="onImportFileRemove"
                    :on-exceed="onImportExceed"
                >
                    <div v-if="importFileRaw" class="pi-upload__file">
                        <i class="el-icon-success pi-upload__ok"></i>
                        <div>
                            <strong>{{ importFileRaw.name }}</strong>
                            <em>已选择，点击「解析预览」核对后写入</em>
                        </div>
                    </div>
                    <div v-else class="pi-upload__empty">
                        <i class="el-icon-upload2"></i>
                        <strong>点击选择或拖拽文件到此处</strong>
                        <em>支持得分表 .xlsx / .xls，或导出的 .zip</em>
                    </div>
                </el-upload>
            </div>
            <div slot="footer" class="pi-footer">
                <el-button @click="importVisible = false">取消</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-view"
                    :loading="importing"
                    :disabled="!importFileRaw"
                    @click="handlePreviewImport"
                >解析预览</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="resultVisible"
            width="860px"
            custom-class="person-import-dialog"
            :close-on-click-modal="false"
            append-to-body
            :before-close="onResultDialogClose"
        >
            <div slot="title" class="pi-dialog-title">
                <span class="pi-dialog-title__icon">
                    <i :class="previewMode ? 'el-icon-view' : 'el-icon-document-checked'"></i>
                </span>
                <div>
                    <strong>{{ previewMode ? '导入预览（尚未写入）' : '导入结果' }}</strong>
                    <p v-if="previewMode">{{ previewSummary }}</p>
                    <p v-else>写入完成，可关闭后在列表中查看</p>
                </div>
            </div>
            <div class="bb-result-toolbar">
                <el-input
                    v-model="resultKeyword"
                    size="small"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="搜索班级 / 原因"
                    style="width: 240px;"
                />
                <el-select
                    v-model="resultStatusFilter"
                    size="small"
                    clearable
                    placeholder="全部状态"
                    style="width: 128px;"
                >
                    <el-option label="待确认" value="Ready" />
                    <el-option label="已写入" value="Settled" />
                    <el-option label="跳过" value="Skipped" />
                    <el-option label="失败" value="Failed" />
                </el-select>
                <span class="bb-result-count">显示 {{ filteredImportResults.length }} / {{ importResults.length }}</span>
            </div>
            <el-table :data="filteredImportResults" class="pi-preview-table" border stripe size="small" max-height="420">
                <el-table-column prop="ClassName" label="班级" min-width="120" show-overflow-tooltip />
                <el-table-column label="评分" width="88" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.Score != null">{{ formatScore(scope.row.Score) }}</span>
                        <span v-else class="muted">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="校区名次" width="88" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.Rank != null">{{ scope.row.Rank }}</span>
                        <span v-else class="muted">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="全校名次" width="88" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.SchoolGradeRank != null">{{ scope.row.SchoolGradeRank }}</span>
                        <span v-else class="muted">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="德育分" width="88" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.MoralScore != null">{{ formatScore(scope.row.MoralScore) }}</span>
                        <span v-else class="muted">-</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="resultTagType(scope.row.Status)" size="mini">{{ resultStatusText(scope.row.Status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Reason" label="原因" min-width="180" show-overflow-tooltip />
            </el-table>
            <div slot="footer" class="pi-footer">
                <template v-if="previewMode">
                    <el-button @click="discardPreview">放弃</el-button>
                    <el-button
                        type="primary"
                        icon="el-icon-upload2"
                        :loading="confirming"
                        :disabled="previewReadyCount <= 0"
                        @click="handleConfirmImport"
                    >确认写入（{{ previewReadyCount }}）</el-button>
                </template>
                <el-button v-else type="primary" @click="closeResultDialog">关闭</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getButtonList } from '../../promissionRouter';
import {
    getBlackboardScoreOverview,
    exportBlackboardPackage,
    previewBlackboardScores,
    confirmBlackboardScores,
    revokeBlackboardScore
} from '../../api/modules/blackboard';
import { read, utils } from 'xlsx';
import JSZip from 'jszip';
import '../../style/person-import-dialog.css';
import { normalizeDeptId, treeNodeDeptId, resolveActiveSchoolId } from '../../utils/deptCascaderProps';

export default {
    name: 'BlackboardScore',
    components: { DepartmentPane },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            schoolId: 0,
            schoolName: '',
            buttonList: [],
            scopeParts: [],
            filterForm: {
                yearMonth: ym,
                campusId: 0,
                gradeId: 0,
                scopeDeptId: 0,
                campusName: '',
                gradeName: '',
                viewLevel: 'school'
            },
            list: [],
            page: 1,
            pageSize: 20,
            pageSizes: [10, 20, 50, 100],
            loading: false,
            exporting: false,
            importing: false,
            confirming: false,
            importVisible: false,
            importUploadKey: 0,
            importFileRaw: null,
            resultVisible: false,
            previewMode: false,
            pendingImportRows: [],
            importResults: [],
            resultKeyword: '',
            resultStatusFilter: ''
        };
    },
    computed: {
        /** 全校、校区或学段时显示校区列 */
        showCampusCol() {
            const level = this.filterForm.viewLevel;
            return level === 'school' || level === 'campus' || level === 'period';
        },
        /** 全校、校区或学段时显示年级列 */
        showGradeCol() {
            const level = this.filterForm.viewLevel;
            return level === 'school' || level === 'campus' || level === 'period';
        },
        /** 当前页班级。得分接口一次返回范围内全部班级，分页在前端切。最后更新：2026-09-24 */
        pagedList() {
            const start = (this.page - 1) * this.pageSize;
            return (this.list || []).slice(start, start + this.pageSize);
        },
        previewReadyCount() {
            return (this.importResults || []).filter(r => r.Status === 'Ready').length;
        },
        previewSummary() {
            const list = this.importResults || [];
            const ready = list.filter(r => r.Status === 'Ready').length;
            const skipped = list.filter(r => r.Status === 'Skipped').length;
            const failed = list.filter(r => r.Status === 'Failed').length;
            return `待写入 ${ready} 班，跳过 ${skipped}，失败 ${failed}。放弃则不会写入任何分数。`;
        },
        /** 预览/结果表本地筛选。创建于 2026-09-24 */
        filteredImportResults() {
            const kw = String(this.resultKeyword || '').trim().toLowerCase();
            const status = this.resultStatusFilter || '';
            return (this.importResults || []).filter(row => {
                if (status && row.Status !== status) return false;
                if (!kw) return true;
                const className = String(row.ClassName || '').toLowerCase();
                const reason = String(row.Reason || '').toLowerCase();
                const statusText = String(this.resultStatusText(row.Status) || '').toLowerCase();
                return className.includes(kw) || reason.includes(kw) || statusText.includes(kw);
            });
        }
    },
    created() {
        this.buttonList = getButtonList(this.$route.path) || [];
        const sid = this.resolveSchoolId();
        if (sid) this.bindSchool(sid, this.$store.state.activeSchoolName);
    },
    watch: {
        '$store.state.activeSchoolId'(newSchoolId) {
            this.bindSchool(newSchoolId, this.$store.state.activeSchoolName);
            this.resetScope();
        }
    },
    methods: {
        hasActionPermission(func) {
            if (!this.buttonList || !this.buttonList.length) return true;
            return this.buttonList.some(button => button.Func === func);
        },
        /** 解析当前学校 Id（字符串，避免雪花 Id 被 Number 截断）。最后修改：2026-10-18 */
        resolveSchoolId() {
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return fromStore;
            const local = normalizeDeptId(this.schoolId);
            if (local) return local;
            return '';
        },
        bindSchool(schoolId, schoolName) {
            const id = normalizeDeptId(schoolId);
            if (!id) return;
            this.schoolId = id;
            if (schoolName) this.schoolName = schoolName;
        },
        resetScope() {
            this.filterForm.campusId = 0;
            this.filterForm.gradeId = 0;
            this.filterForm.scopeDeptId = 0;
            this.filterForm.campusName = '';
            this.filterForm.gradeName = '';
            this.filterForm.viewLevel = 'school';
            this.scopeParts = [];
            this.list = [];
        },
        orgTypeOf(data) {
            return String((data && (data.DeptOrgType || data.deptOrgType)) || '').toLowerCase();
        },
        findAncestor(node, orgType) {
            let cur = node;
            const want = String(orgType || '').toLowerCase();
            while (cur) {
                const d = cur.data || cur;
                if (this.orgTypeOf(d) === want) {
                    return {
                        id: treeNodeDeptId(d),
                        name: d.label || d.Name || d.name || ''
                    };
                }
                cur = cur.parent;
            }
            return { id: '', name: '' };
        },
        /**
         * 左侧教学树：仅筛选查看范围；导出/导入始终全校。
         * 创建于 2026-09-24
         */
        treeNodeClick(data, node) {
            if (!data) {
                this.resetScope();
                return;
            }
            const sid = this.resolveSchoolId();
            if (sid) this.bindSchool(sid, this.$store.state.activeSchoolName);

            const orgType = this.orgTypeOf(data);
            const id = treeNodeDeptId(data);
            const label = data.label || data.Name || data.name || '';

            this.filterForm.campusId = 0;
            this.filterForm.gradeId = 0;
            this.filterForm.scopeDeptId = 0;
            this.filterForm.campusName = '';
            this.filterForm.gradeName = '';
            this.scopeParts = [];

            if (orgType === 'period') {
                const campus = this.findAncestor(node, 'campus');
                this.filterForm.scopeDeptId = id;
                this.filterForm.campusId = campus.id;
                this.filterForm.campusName = campus.name;
                this.filterForm.viewLevel = 'period';
                this.scopeParts = [
                    ...(campus.name ? [{ label: campus.name, type: '' }] : []),
                    { label: label || '学段', type: 'warning' }
                ];
            } else if (orgType === 'grade') {
                const campus = this.findAncestor(node, 'campus');
                this.filterForm.gradeId = id;
                this.filterForm.gradeName = label;
                this.filterForm.campusId = campus.id;
                this.filterForm.campusName = campus.name;
                this.filterForm.viewLevel = 'grade';
                this.scopeParts = [
                    ...(campus.name ? [{ label: campus.name, type: '' }] : []),
                    { label: label || '年级', type: 'success' }
                ];
            } else if (orgType === 'class') {
                const grade = this.findAncestor(node, 'grade');
                const campus = this.findAncestor(node, 'campus');
                this.filterForm.gradeId = grade.id;
                this.filterForm.gradeName = grade.name;
                this.filterForm.campusId = campus.id;
                this.filterForm.campusName = campus.name;
                this.filterForm.viewLevel = 'grade';
                this.scopeParts = [
                    ...(campus.name ? [{ label: campus.name, type: '' }] : []),
                    ...(grade.name ? [{ label: grade.name, type: 'success' }] : [])
                ];
            } else if (orgType === 'campus') {
                this.filterForm.campusId = id;
                this.filterForm.campusName = label;
                this.filterForm.viewLevel = 'campus';
                this.scopeParts = [
                    { label: label || '校区', type: '' },
                    { label: '全年级', type: 'success' }
                ];
            } else {
                // 学校根或其它：全校
                this.filterForm.viewLevel = 'school';
                this.scopeParts = [{ label: label || this.schoolName || '全校', type: '' }];
            }
            this.handleSearch();
        },
        handleSearch() {
            this.page = 1;
            this.loadList();
        },
        onPageChange(p) {
            this.page = p;
        },
        onPageSizeChange(size) {
            this.pageSize = size;
            this.page = 1;
        },
        scoreRowIndex(index) {
            return (this.page - 1) * this.pageSize + index + 1;
        },
        async loadList() {
            if (!this.schoolId || !this.filterForm.yearMonth) {
                this.list = [];
                return;
            }
            this.loading = true;
            try {
                const res = await getBlackboardScoreOverview({
                    schoolId: this.schoolId,
                    campusId: this.filterForm.campusId || 0,
                    gradeId: this.filterForm.gradeId || 0,
                    scopeDeptId: this.filterForm.scopeDeptId || 0,
                    yearMonth: this.filterForm.yearMonth
                });
                if (res.data && res.data.success) {
                    this.list = res.data.response || [];
                } else {
                    this.list = [];
                    this.$message.error((res.data && res.data.msg) || '加载失败');
                }
            } catch (e) {
                this.list = [];
                this.$message.error('加载失败');
            } finally {
                this.loading = false;
            }
        },
        formatScore(v) {
            const n = Number(v);
            if (Number.isNaN(n)) return '-';
            return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
        },
        settleText(status) {
            if (status === 'Settled') return '已写入';
            if (status === 'Revoked') return '已撤销';
            if (status === 'Failed') return '失败';
            if (status === 'Skipped') return '跳过';
            return '未结算';
        },
        settleTagType(status) {
            if (status === 'Settled') return 'success';
            if (status === 'Revoked') return 'info';
            if (status === 'Failed') return 'danger';
            if (status === 'Skipped') return 'warning';
            return '';
        },
        resultTagType(status) {
            if (status === 'Settled') return 'success';
            if (status === 'Ready') return 'warning';
            if (status === 'Skipped') return 'info';
            if (status === 'Failed') return 'danger';
            return 'warning';
        },
        resultStatusText(status) {
            if (status === 'Ready') return '待确认';
            if (status === 'Settled') return '已写入';
            if (status === 'Skipped') return '跳过';
            if (status === 'Failed') return '失败';
            return status || '-';
        },
        ensureMonth() {
            if (!this.schoolId) {
                this.$message.warning('请先选择学校');
                return false;
            }
            if (!this.filterForm.yearMonth) {
                this.$message.warning('请选择年月');
                return false;
            }
            return true;
        },
        async handleExport() {
            if (!this.ensureMonth()) return;
            this.exporting = true;
            try {
                const res = await exportBlackboardPackage({
                    schoolId: this.schoolId,
                    yearMonth: this.filterForm.yearMonth
                });
                const blob = res.data;
                if (blob && blob.type && blob.type.indexOf('application/json') >= 0) {
                    const text = await blob.text();
                    let msg = '导出失败';
                    try {
                        const json = JSON.parse(text);
                        msg = json.msg || msg;
                    } catch (err) { /* 非 JSON */ }
                    this.$message.error(msg);
                    return;
                }
                const schoolLabel = this.schoolName || '全校';
                const fileName = `黑板报_${this.filterForm.yearMonth}_${schoolLabel}.zip`;
                const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/zip' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(url);
                this.$message.success('已导出评分压缩包');
            } catch (e) {
                this.$message.error('导出失败');
            } finally {
                this.exporting = false;
            }
        },
        openImportDialog() {
            if (!this.ensureMonth()) return;
            this.importFileRaw = null;
            this.importUploadKey += 1;
            this.importVisible = true;
        },
        onImportDialogClosed() {
            this.importFileRaw = null;
            this.importUploadKey += 1;
        },
        onImportFileChange(file) {
            this.importFileRaw = file && file.raw ? file.raw : null;
        },
        onImportFileRemove() {
            this.importFileRaw = null;
        },
        onImportExceed(files) {
            const next = files && files[0];
            if (next) this.importFileRaw = next;
            this.importUploadKey += 1;
        },
        buildImportPayload(rows) {
            return {
                schoolId: this.schoolId,
                campusId: 0,
                gradeId: 0,
                yearMonth: this.filterForm.yearMonth,
                rows
            };
        },
        /** 解析得分表（xlsx 或压缩包内的得分表）并预览，不写库。创建于 2026-09-24 */
        handlePreviewImport() {
            if (!this.importFileRaw) {
                this.$message.warning('请先选择文件');
                return;
            }
            if (!/\.(xls|xlsx|zip)$/i.test(this.importFileRaw.name)) {
                this.$message.error('请上传得分表（xls / xlsx）或导出的压缩包（zip）');
                return;
            }
            this.importing = true;
            const reader = new FileReader();
            reader.onload = async (ev) => {
                try {
                    const buffer = ev.target.result;
                    const workbook = /\.zip$/i.test(this.importFileRaw.name)
                        ? await this.readWorkbookFromZip(buffer)
                        : read(buffer, { type: 'array' });
                    if (!workbook) {
                        this.$message.error('压缩包中未找到得分表.xlsx');
                        this.importing = false;
                        return;
                    }
                    const sheet = workbook.Sheets[workbook.SheetNames[0]];
                    const jsonRows = utils.sheet_to_json(sheet, { defval: '' });
                    const rows = this.mapImportRows(jsonRows);
                    if (!rows.length) {
                        this.$message.warning('未解析到有效数据行');
                        this.importing = false;
                        return;
                    }
                    const res = await previewBlackboardScores(this.buildImportPayload(rows));
                    if (res.data && res.data.success) {
                        this.pendingImportRows = rows;
                        this.importResults = res.data.response || [];
                        this.resultKeyword = '';
                        this.resultStatusFilter = '';
                        this.previewMode = true;
                        this.importVisible = false;
                        this.resultVisible = true;
                        // 预览弹窗已说明状态，不再额外 toast，避免被遮罩挡住
                    } else {
                        this.$message.error((res.data && res.data.msg) || '预览失败');
                    }
                } catch (e) {
                    this.$message.error('预览失败');
                } finally {
                    this.importing = false;
                }
            };
            reader.onerror = () => {
                this.importing = false;
                this.$message.error('文件读取失败');
            };
            reader.readAsArrayBuffer(this.importFileRaw);
        },
        /** 从压缩包取出得分表，忽略作品图片。创建于 2026-09-24 */
        async readWorkbookFromZip(buffer) {
            const zip = await JSZip.loadAsync(buffer);
            const names = Object.keys(zip.files || {});
            const hit = names.find(name => /(^|\/)得分表\.xlsx$/i.test(name) && !zip.files[name].dir)
                || names.find(name => /\.xlsx$/i.test(name) && !/作品\//.test(name) && !zip.files[name].dir);
            if (!hit) return null;
            const data = await zip.files[hit].async('arraybuffer');
            return read(data, { type: 'array' });
        },
        /** 确认写入值周与名次。创建于 2026-09-24 */
        async handleConfirmImport() {
            if (!this.pendingImportRows.length) {
                this.$message.warning('没有可确认的数据，请重新上传预览');
                return;
            }
            if (this.previewReadyCount <= 0) {
                this.$message.warning('没有可写入的班级');
                return;
            }
            try {
                await this.$confirm(
                    `将按校区名次给 ${this.previewReadyCount} 个班级写入德育分（未命中范围的只记排名）。确认继续？`,
                    '确认写入',
                    { type: 'warning' }
                );
            } catch (e) {
                return;
            }
            this.confirming = true;
            try {
                const res = await confirmBlackboardScores(this.buildImportPayload(this.pendingImportRows));
                if (res.data && res.data.success) {
                    this.importResults = res.data.response || [];
                    this.resultKeyword = '';
                    this.resultStatusFilter = '';
                    this.previewMode = false;
                    this.pendingImportRows = [];
                    this.$message.success(res.data.msg || '写入完成');
                    this.loadList();
                } else {
                    this.$message.error((res.data && res.data.msg) || '写入失败');
                }
            } catch (e) {
                this.$message.error('写入失败');
            } finally {
                this.confirming = false;
            }
        },
        discardPreview() {
            this.pendingImportRows = [];
            this.importResults = [];
            this.resultKeyword = '';
            this.resultStatusFilter = '';
            this.previewMode = false;
            this.resultVisible = false;
            this.$message.info('已放弃，未写入任何分数');
        },
        closeResultDialog() {
            this.resultVisible = false;
            this.previewMode = false;
            this.pendingImportRows = [];
            this.resultKeyword = '';
            this.resultStatusFilter = '';
        },
        onResultDialogClose(done) {
            if (this.previewMode && this.pendingImportRows.length) {
                this.$confirm('关闭后将放弃本次预览，不会写入分数。确定？', '提示', { type: 'warning' })
                    .then(() => {
                        this.pendingImportRows = [];
                        this.previewMode = false;
                        this.resultKeyword = '';
                        this.resultStatusFilter = '';
                        done();
                    })
                    .catch(() => {});
                return;
            }
            this.previewMode = false;
            this.pendingImportRows = [];
            this.resultKeyword = '';
            this.resultStatusFilter = '';
            done();
        },
        mapImportRows(jsonRows) {
            const pick = (row, keys) => {
                for (let i = 0; i < keys.length; i++) {
                    if (row[keys[i]] !== undefined && row[keys[i]] !== null && row[keys[i]] !== '') {
                        return row[keys[i]];
                    }
                }
                return '';
            };
            return (jsonRows || []).map(row => {
                const classId = this.parseClassId(pick(row, ['班级Id', '班级ID', 'ClassId', 'classId']));
                const scoreRaw = pick(row, ['得分', 'Score', 'score']);
                let score = null;
                if (scoreRaw !== '' && scoreRaw !== null && scoreRaw !== undefined) {
                    const n = Number(scoreRaw);
                    if (!Number.isNaN(n)) score = n;
                }
                return {
                    YearMonth: String(pick(row, ['年月', 'YearMonth', 'yearMonth']) || this.filterForm.yearMonth),
                    CampusName: String(pick(row, ['校区', 'CampusName', 'campusName']) || ''),
                    GradeName: String(pick(row, ['年级', 'GradeName', 'gradeName']) || ''),
                    ClassId: classId,
                    ClassName: String(pick(row, ['班级名', '班级', 'ClassName', 'className']) || ''),
                    Score: score
                };
            }).filter(r => normalizeDeptId(r.ClassId));
        },
        /** 解析班级 Id 为十进制字符串，避免 Number 截断雪花 Id。最后修改：2026-10-18 */
        parseClassId(raw) {
            return normalizeDeptId(raw);
        },
        handleRevoke(row) {
            this.$confirm(`确认撤销「${row.ClassName}」本月已写入的黑板报得分？将同步删除对应值周记录。`, '提示', {
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await revokeBlackboardScore({ scoreId: row.ScoreId });
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '已撤销');
                        this.loadList();
                    } else {
                        this.$message.error((res.data && res.data.msg) || '撤销失败');
                    }
                } catch (e) {
                    this.$message.error('撤销失败');
                }
            }).catch(() => {});
        }
    }
};
</script>

<style scoped>
.filter-bar { margin-bottom: 8px; }
.scope-bar {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-left: 8px;
    vertical-align: middle;
}
.scope-tag {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tip-alert { margin-bottom: 12px; }
.tbl-scroll-host { flex: 1; min-height: 320px; }
.pager { text-align: right; margin-top: 12px; }
.muted { color: #909399; }
.no-department-tip {
    display: flex; align-items: center; justify-content: center;
    height: 100%; min-height: 280px;
}
.no-department-tip__inner { text-align: center; color: #909399; }
.no-department-tip__inner i { font-size: 48px; margin-bottom: 12px; }
</style>

<!-- append-to-body 弹窗需非 scoped，否则 flex/宽度会失效叠成两行 -->
<style>
.person-import-dialog .bb-result-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 10px;
    margin: 0 0 12px;
    padding: 10px 12px;
    border-radius: 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
}
.person-import-dialog .bb-result-toolbar .el-input,
.person-import-dialog .bb-result-toolbar .el-select {
    flex: 0 0 auto;
}
.person-import-dialog .bb-result-count {
    margin-left: auto;
    font-size: 12px;
    color: #64748b;
    white-space: nowrap;
}
</style>
